import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TRUSTPAISA_URL, CASHE_URL } from '../../Constants';
import './LenderPage.css';

const LenderPage = () => {
    const { lenderName } = useParams();
    const navigate = useNavigate();
    const [iframeUrl, setIframeUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Map lender names to their URLs
        const lenderUrls = {
            'trustpaisa': TRUSTPAISA_URL,
            'cashe': CASHE_URL,
        };

        const url = lenderUrls[lenderName?.toLowerCase()];
        
        if (url) {
            setIframeUrl(url);
            setIsLoading(false);
        } else {
            // If invalid lender name, redirect to home
            navigate('/');
        }
    }, [lenderName, navigate]);

    // Add page title based on lender
    useEffect(() => {
        if (lenderName) {
            const lenderTitle = lenderName === 'trustpaisa' ? 'TrustPaisa' : 'Cashe';
            document.title = `Apply with ${lenderTitle} - Snapfunds`;
        }
    }, [lenderName]);

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    const handleIframeError = () => {
        setIsLoading(false);
        // Handle iframe loading error
        console.error('Failed to load lender page');
    };

    if (!iframeUrl) {
        return (
            <div className="container mt-5 text-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading lender page...</p>
            </div>
        );
    }

    return (
        <div className="lender-page-container">
            {isLoading && (
                <div className="iframe-loading-overlay">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading {lenderName}...</p>
                </div>
            )}
            
            <iframe
                src={iframeUrl}
                title={`${lenderName} Application`}
                className="lender-iframe"
                onLoad={handleIframeLoad}
                onError={handleIframeError}
                frameBorder="0"
                allowFullScreen
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
            />
        </div>
    );
};

export default LenderPage;
